import { render, staticRenderFns } from "./ExtraProfile.vue?vue&type=template&id=47c96f4a&"
import script from "./ExtraProfile.vue?vue&type=script&lang=ts&"
export * from "./ExtraProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports